<template>
    <div class="wide-inner" v-if="footerHtml" v-html="footerHtml"></div>
    <div class="wide-inner" v-else><!-- Default footer --></div>
</template>
<script>

export default {
    name: 'Footer',

    props: {
        isMobile: {
            required: true,
            type: Boolean
        },
    },

    data() {
        return {
			footerHtml: window.configuration.footerHtml,
        };
    },
}
</script>
